import { type RootState } from "../redux/store";

export const selectRegionaBannerVisibility = (state: RootState): boolean => {
  return state.regionSelectionBanner.isVisible;
};
